import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../modal.service';
import { MatDialog } from '@angular/material/dialog';
import { FacetecVideoModalComponent } from '@shared/information/modal/facetec-video-modal/facetec-video-modal.component';

@Component({
  selector: 'shell-validate-identity',
  templateUrl: './validate-identity.component.html',
  styleUrls: ['./validate-identity.component.scss'],
})
export class ValidateIdentityComponent implements OnInit {
  constructor(public modalService: ModalService, private dialog: MatDialog) {}

  ngOnInit() {}

  showVideo() {
    this.dialog.open(FacetecVideoModalComponent).afterClosed().subscribe();
  }

  closeModal() {
    this.modalService.close();
  }
}
